import { gql } from '@apollo/client';

export default gql`
  mutation UserLoginTwoFactor($code: String!) {
    userLoginTwoFactor(input: { code: $code }) {
      expiresIn
    }
  }
`;
